export default __webpack_public_path__ + "static/media/4g-dro.3552f7f2.jpg";